exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wraper--tree[data-v-03278348]{height:500px}", ""]);

// exports
